<template>
  <div class="root">
    <div class="top">实名认证</div>
    <template v-if="step == 1">
    <div class="title-1">1、请上传二代身份证</div>
    <div class="title-2">请确保上传本人清晰、完整、有效的身份证</div>
    <div class="upload-box">
      <div class="box-item">
        <van-uploader :after-read="afterReadFront" class="img">
          <img :src="fileForm.front.content" v-if="fileForm.front" class="idcard"/>
          <img src="../assets/newimg/guohui.png" v-else class="idcard"/>
          <img src="../assets/newimg/shangchuan.png" class="icon"/>
        </van-uploader>
        <div class="text">上传人像面</div>
      </div>
      <div class="box-item">
        <van-uploader :after-read="afterReadBack" class="img">
          <img :src="fileForm.back.content" v-if="fileForm.back" class="idcard"/>
          <img src="../assets/newimg/guohui.png" v-else class="idcard"/>
          <img src="../assets/newimg/shangchuan.png" class="icon"/>
        </van-uploader>>
        <div class="text">上传国徽面</div>
      </div>
    </div>
    <div class="tips">
      <div class="tips-item">
        <img src="../assets/newimg/cuowu.png"/>
        <span>边框确实</span>
      </div>
      <div class="tips-item">
        <img src="../assets/newimg/cuowu.png"/>
        <span>照片模糊</span>
      </div>
      <div class="tips-item">
        <img src="../assets/newimg/cuowu.png"/>
        <span>反光强烈</span>
      </div>
    </div>
    <div class="step" @click="netStep">下一步</div>
    </template>
    <template v-else>
      <div class="title-1">2、请完成手机验证</div>
      <div class="phone-form">
        <div class="input-control">
          <div class="label">手机号：</div>
          <input v-model="ruleForm.mobile" placeholder="请输入您的11位手机号码" />
        </div>
        <div class="input-control">
          <div class="label">验证码：</div>
          <input v-model="ruleForm.code" />
          <span class="addon" @click="handleSms">{{ smsBtnTxt }}</span>
        </div>
      </div>
      <div class="btn-group">
        <div class="return-btn" @click="step=1">上一步</div>
        <div class="submit" @click="submit">提交</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "recharge",
  data() {
    return {
      step: 1,
      ruleForm:{

      },
      fileForm:{
        front:'',
        back:'',
      },
      sms:false,
      smsBtnTxt:'发送验证码',
    }
  },
  methods:{
    async submit(){
      if(!this.fileForm.front){
        this.step = 1;
        return this.$toast('请上传人像面')
      }
      if(!this.fileForm.back){
        this.step = 1;
        return this.$toast('请上传国徽面')
      }
      if(!this.ruleForm.mobile || !this.ruleForm.code){
        return this.$toast('请输入手机号和验证码')
      }
      this.$toast.loading({duration:0,forbidClick:true,message:'认证中'})
      let uploadres
      if(!this.ruleForm.front) {
        uploadres = await this.uploadsync('/base/upload', this.fileForm.front.file)
        if (!uploadres.code) {
          return this.$toast(uploadres.msg)
        }
        this.ruleForm.front = uploadres.data
      }
      if(!this.ruleForm.back) {
        uploadres = await this.uploadsync('/base/upload', this.fileForm.back.file)
        if (!uploadres.code) {
          return this.$toast(uploadres.msg)
        }
        this.ruleForm.back = uploadres.data
      }
      this.post("/card/localtuth",this.ruleForm).then(res=>{
        this.$toast.loading().clear();
        this.$toast(res.msg)
        if(res.code){
          this.$router.back()
        }
      }).catch(err=>{})
    },
    netStep(){
      if(!this.fileForm.front){
        return this.$toast('请上传人像面')
      }
      if(!this.fileForm.back){
        return this.$toast('请上传国徽面')
      }
      this.step = 2
    },
    afterReadFront(file){
      if(file.size > 2*1024*1024){
        return this.$toast("请上传小于2M的图片")
      }
      this.fileForm.front = file
    },
    afterReadBack(file){
      if(file.size > 2*1024*1024){
        return this.$toast("请上传小于2M的图片")
      }
      this.fileForm.back = file
    },
    handleSms(){
      if(!/^1[\d]{10}/.test(this.ruleForm.mobile)){
        return this.$toast("请输入正确的手机号码")
      }
      if(this.sms == false) {
        this.sms = true
        this.$toast.loading({duration:0,forbidClick:true})
        this.fetchData('/sms/send', {mobile: this.ruleForm.mobile}, (res) => {
          this.$toast.clear();
          if (res.code) {
            this.$toast('发送成功')
            let s = 60;
            let intval = setInterval(()=>{
              this.smsBtnTxt = s+'秒重发'
              if(s <= 0){
                this.smsBtnTxt = '发送验证码';
                this.sms = false;
                clearInterval(intval);
              }
              s--;
            },1000)

          } else {
            this.sms = false;
            this.$toast('发送失败')
          }
        })
      }
    },
  },
  created() {
    this.ruleForm.iccid = this.$route.query.iccid
  }
}
</script>
<style scoped lang="scss">
.root {
  height: inherit;
  font-size: 0;
  background: #fff5f6;
  overflow-y: scroll;
  .btn-group{
    display: flex;
    margin-top: 1rem;
    div{
      color: #fff;
      width: 1.6rem;
      height: .6rem;
      border-radius: .1rem;
      line-height: .6rem;
      text-align: center;
      font-size: .28rem;
      margin: 0 auto;
    }
    .return-btn{
      background: #dadada;
    }
    .submit{
      background: #ff574e;
    }
  }

  .phone-form {
    width: 6rem;
    margin: .6rem auto;
    .input-control{
      position: relative;
      font-size: .28rem;
      margin-top: .26rem;
      width: 6rem;
      .label{
        line-height: .8rem;
        font-size: .3rem;
        letter-spacing: .03rem;
      }
      input{
        width:6rem;
        border: none;
        background: #dedede;
        height: .8rem;
        line-height: .8rem;
        text-indent: .1rem;
        padding: 0;
      }
      .addon{
        position: absolute;
        line-height: .8rem;
        top: .8rem;
        right: .4rem;
        color: #0b8ed4;
      }
    }
  }
  .step{
    width: 1.6rem;
    height: .6rem;
    text-align: center;
    line-height: .6rem;
    border-radius: .1rem;
    background: #ff574e;
    color: #fff;
    font-size: .28rem;
    margin: .4rem auto;
  }
.tips{
  width: 6.5rem;
  margin: .1rem auto;
  text-align: center;
  display: flex;
  .tips-item{
    flex: 1;
    img{
      width: .2rem;
      height: .2rem;
      vertical-align: middle;
      display: inline-block;
    }
    span{
      margin-left: .06rem;
      vertical-align: middle;
      font-size: .2rem;
      color: #ff574e;
    }
  }

}
  .top {
    font-size: .34rem;
    text-align: center;
    font-weight: bold;
    padding: .82rem 0 .4rem;
    background: #ff574e;
  }
  .title-1{
    text-align: center;
    font-size: .5rem;
    margin-top: .6rem;
  }
  .title-2{
    font-size: .28rem;
    text-align: center;
    color: #aaa;
  }
  .upload-box{
    padding:0 0 .4rem 0;
    border-bottom: 1px solid #000;
    .box-item{
      margin-top: .4rem;
      .text{
        text-align: center;
        font-size: .26rem;
        margin-top: .2rem;
      }
      .img{
        width: 4.5rem;
        margin: 0 auto;
        height: 2.8rem;
        position: relative;
        background: #fed6d6;
        text-align: center;
        display: block;
        .idcard{
          width: 3.5rem;
          height: 2rem;
          margin: .4rem .5rem;
          display: inline-block;
        }
        .icon{
          position: absolute;
          width: .7rem;
          height: .8rem;
          left: 1.9rem;
          top: 1rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/authpage.vue